import React, { FC } from "react";
import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import sideBarStyles from "./sidebar.module.css";
import { ImgURL } from "../../../Url";
import { SectionsList } from "./SideBarInterface";

interface SectionListItemPropsInterface {
  value: SectionsList;
  onClick: (id: string) => void;
  onCollapse: (id: string) => void;
  selected: boolean;
  collapse: boolean;
  expandButton: boolean;
}
//eslint-disable-next-line
const ListItemSmeta: FC<SectionListItemPropsInterface> = ({
  value: { ID: id, Image: img, Name: name, Title: title, $tag },
  selected,
  expandButton,
  collapse,
  onCollapse,
  onClick,
}) => {
  const theme = "light";

  const handleExpand = () => {
    onCollapse(id);
  };
  const handleClick = () => {
    onClick(id);
  };
  const tagStyle = {
    "--tag": Number($tag),
  } as React.CSSProperties;

  return (
    <ListItem
      component="div"
      className={clsx(sideBarStyles.ListItem)}
      style={tagStyle}
      secondaryAction={
        <IconButton
          id={id}
          onClick={handleExpand}
          className={clsx(
            sideBarStyles.ExpandButton,
            expandButton ? sideBarStyles.ExpandButtonVisible : sideBarStyles.ExpandButtonHidden,
          )}
        >
          {collapse ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
      }
    >
      <ListItemButton
        component="div"
        id={id}
        selected={selected}
        onClick={handleClick}
        className={clsx(sideBarStyles.ListItemButton, selected && sideBarStyles.ListItemButtonSelected)}
      >
        <ListItemIcon className={clsx(sideBarStyles.ListItemImg, !img && sideBarStyles.ListItemImgHidden)}>
          {img ? ImgURL(img, { height: 32 }) : ""}
        </ListItemIcon>
        <ListItemText
          className={clsx("fontColorStimate", { light: true })}
          primary={
            <div className={clsx(sideBarStyles.ListItemText)} title={title || name}>
              {title || name}
            </div>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};

export default ListItemSmeta;
